export const LocationSelectProps = [
  {
    value: "ARANDJELOVAC",
    label: "ARANDJELOVAC",
  },
  {
    value: "MALI ZVORNIK",
    label: "MALI ZVONIK",
  },
  {
    value: "LIPNICKI SOR",
    label: "LIPNICKI SOR",
  },
];
